import React, { useState } from "react";
import { Autocomplete } from "@material-ui/lab";
import { TextField, Divider } from "@material-ui/core";
import AccountCircle from "@material-ui/icons/AccountCircle";
import { styles } from "./styles";
import logoutIcon from "../../img/logout1.png";
import { version } from "../../config/config";
import {
  decryptAes,
  decryptAesObj,
} from "../CommonComponents/AESencryptdecrypt";
import { LogoutAction } from "../../actions/logout";
import config from "../../config/config";
import AlertDialog from "../CommonComponents/confirmDialog";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import {
  Button,
  ClickAwayListener,
  Grow,
  ListItemIcon,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from "@mui/material";
import CahngePasswordModal from "./CahngePasswordModal";
import { changepasswordAction } from "../../actions/ChangePassword";
const RightSideHeader = () => {
  const [setIsOpen, setOpen] = React.useState(false);
  const [open, setOpenModal] = useState(false);
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);
  const [currentPassword, setcurrentPassword] = useState("");
  const [newPassword, setnewPassword] = useState("");
  const [confirmPassword, setconfirmPassword] = useState("");
  const [checkValidation, setCheckValidation] = useState(false);

  const anchorRef = React.useRef(null);
  const oldPassword = decryptAesObj(
    localStorage.getItem("data")
  )?.userProvidedPassword;
  const logoutFunc = () => {
    LogoutAction.userLogout(`${config.baseUrl}${config.apiName.logout}`)
      .then((response) => {
        window.open(`/`, "_self");
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleLogout = async () => {
    setOpen(true);
    // logoutFunc()
    // window.open(`/`, '_self')

    // window.localStorage.clear()
  };

  function handleAlertClose() {
    setOpen(false);
  }

  function removeImage() {
    setOpen(false);
    logoutFunc();
  }
  const changepassword = () => {
    setPasswordModalOpen(true);
  };

  const Closechangepassword = () => {
    setcurrentPassword("");
    setconfirmPassword("");
    setnewPassword("");
    setPasswordModalOpen(false);
  };
  const handleToggle = () => {
    setOpenModal((prevOpen) => !prevOpen);
  };

  const onmouseMove = () => {
    setOpenModal(true);
  };


  const handleClose = (event) => {
    if (anchorRef.current && anchorRef?.current?.contains(event?.target)) {
      return;
    }
    setOpenModal(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpenModal(false);
    }
  }

  const changepasswordhandler = () => {
    const myArray = newPassword.trim().split(" ");
    if (checkValidation) {
      alert("Please fix the errors before submitting");
      return false;
    } else if (currentPassword == "") {
      alert("Please Enter Your  Old Password");
      return false;
    } else if (currentPassword !== oldPassword) {
      alert("Please enter correct old password");
      return false;
    } else if (newPassword == "") {
      alert("Please Enter Your  New Password");
      return false;
    } else if (myArray.length > 1) {
      alert("No space allowed!!!");
      return false;
    } else if (confirmPassword == "") {
      alert("Please Enter Your  Confirm Password");
      return false;
    } else if (confirmPassword !== newPassword) {
      alert("New and confirm Password must be same ");
      return false;
    }
    console.log(decryptAesObj(localStorage.getItem("data")), "asdfghjkl");
    const data = {
      username: decryptAesObj(localStorage.getItem("data"))?.actualEmail,
      oldPassword: currentPassword,
      password: confirmPassword,
    };

    changepasswordAction.changePassword(data).then((response) => {
      if (response != null) {
        alert("Your Password Changed successfully");
        window.open("/", "_self");
      } else if (response.responseCode == 403) {
        alert("Old password doesnt match! ");
      } else {
        console.log("error");
      }
    });
    setcurrentPassword("");
    setconfirmPassword("");
    setnewPassword("");
    setPasswordModalOpen(false);
  };

  return (
    <>
      <AlertDialog
        handleAlertClose={handleAlertClose}
        openAlert={setIsOpen}
        removeImage={removeImage}
        title="Are you sure want to logout?"
      />
      <div style={styles.rightSubCont} id="nav_header">
        <span
          style={{
            position: "absolute",
            right: "5px",
            bottom: "0px",
            color: "white",
            fontSize: "10px",
          }}
        >
          {version}
        </span>
        {/* <Autocomplete id='header'
        getOptionLabel={(option) => option.name}
        className='headerSelect'
        options={[]}
        style={{ width: 200 }}
        filterSelectedOptions
        getOptionSelected={(option, value) => option.name === value.name}
        disableClearable
        renderInput={(params) =>
          <TextField
            {...params}
            variant='outlined'
            margin='dense'
          />
        }
      /> */}

        <CahngePasswordModal
          passwordModalOpen={passwordModalOpen}
          setPasswordModalOpen={setPasswordModalOpen}
          Closechangepassword={Closechangepassword}
          currentPassword={currentPassword}
          newPassword={newPassword}
          confirmPassword={confirmPassword}
          setcurrentPassword={setcurrentPassword}
          setnewPassword={setnewPassword}
          setconfirmPassword={setconfirmPassword}
          changepasswordhandler={changepasswordhandler}
          checkValidation={checkValidation}
          setCheckValidation={setCheckValidation}
        />

        <div>
          <Button
            ref={anchorRef}
            aria-controls={open ? "menu-list-grow" : undefined}
            aria-haspopup="true"
            onClick={handleToggle}

          >
            <span style={styles.span} className="mr-3">
              {window.location.pathname !== "/guestTracking" ? (
                <>
                  <span style={styles.span} className="mr-2">
                    <b style={{ fontSize: "2rem", letterSpacing: ".2rem" }}>
                      {decryptAesObj(localStorage.getItem("data")) &&
                      decryptAesObj(localStorage.getItem("data")).companyId == 5
                        ? "MS"
                        : "SS"}
                    </b>
                  </span>
                  <span
                    style={styles.span}
                    className="mr-5"
                    onMouseEnter={onmouseMove}
                  >
                    <AccountCircle style={styles.userIcon} />
                    <b>
                      {decryptAes(localStorage.getItem("email"))
                        ? decryptAesObj(localStorage.getItem("data"))?.name
                        : ""}
                    </b>
                  </span>
                </>
              ) : (
                ""
              )}
            </span>
          </Button>

          <Popper
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            transition
            disablePortal
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom" ? "center top" : "center bottom",
                }}
              >
                <Paper style={{ marginTop: "5px" }}>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList
                      autoFocusItem={open}
                      id="menu-list-grow"
                      onKeyDown={handleListKeyDown}
                    >
                      <MenuItem onClick={changepassword}>
                        <ListItemIcon>
                          <LockOpenIcon style={{ margin: "0 5px" }} />
                          <b>Change Password</b>
                        </ListItemIcon>
                      </MenuItem>
                      <MenuItem onClick={handleLogout}>
                        <ListItemIcon>
                          <ExitToAppIcon style={{ margin: "0 5px" }} />
                          <b>Logout</b>
                        </ListItemIcon>
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </div>
    </>
  );
};

export default RightSideHeader;
